import React from 'react';

function InstagramIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <circle
        r="15.5"
        fill="#FFC228"
        stroke="#FFC228"
        transform="matrix(-1 0 0 1 16 16)"
      />
      <path
        fill="#262626"
        d="M16 11.194A4.8 4.8 0 0120.809 16 4.8 4.8 0 0116 20.808 4.8 4.8 0 0111.194 16 4.8 4.8 0 0116 11.194zm0 7.931a3.13 3.13 0 003.125-3.124 3.13 3.13 0 00-3.124-3.125 3.13 3.13 0 00-3.124 3.125A3.13 3.13 0 0016 19.125zm-5.003-9.248a1.121 1.121 0 110 2.245 1.12 1.12 0 01-1.038-1.553 1.122 1.122 0 011.038-.692zM6.631 16c0-1.294-.012-2.576.06-3.867.073-1.5.415-2.832 1.512-3.929 1.1-1.099 2.428-1.439 3.928-1.511 1.294-.073 2.576-.061 3.867-.061 1.294 0 2.576-.012 3.868.06 1.5.073 2.831.416 3.928 1.512 1.1 1.1 1.439 2.429 1.512 3.929.072 1.293.06 2.575.06 3.867 0 1.291.012 2.575-.06 3.867-.073 1.5-.415 2.831-1.512 3.928-1.1 1.1-2.428 1.44-3.928 1.512-1.294.072-2.576.06-3.867.06-1.294 0-2.576.012-3.868-.06-1.5-.073-2.83-.415-3.928-1.512-1.099-1.1-1.439-2.428-1.512-3.928-.075-1.291-.06-2.573-.06-3.867zm2.062 5.526c.171.427.377.746.708 1.074.33.33.647.537 1.073.708 1.233.49 4.16.38 5.527.38 1.366 0 4.296.11 5.529-.378a2.978 2.978 0 001.073-.708c.33-.33.537-.647.708-1.073.488-1.236.377-4.163.377-5.53 0-1.366.11-4.295-.377-5.528a2.978 2.978 0 00-.708-1.074 3.03 3.03 0 00-1.073-.707c-1.233-.488-4.163-.378-5.53-.378-1.366 0-4.295-.11-5.528.378a2.978 2.978 0 00-1.073.707c-.33.33-.537.647-.708 1.074-.488 1.233-.378 4.162-.378 5.529 0 1.366-.11 4.293.38 5.526z"
      />
    </svg>
  );
}

export default InstagramIcon;
